"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfVaccinationRecordsDto = instanceOfVaccinationRecordsDto;
exports.VaccinationRecordsDtoFromJSON = VaccinationRecordsDtoFromJSON;
exports.VaccinationRecordsDtoFromJSONTyped = VaccinationRecordsDtoFromJSONTyped;
exports.VaccinationRecordsDtoToJSON = VaccinationRecordsDtoToJSON;
exports.VaccinationRecordsDtoToJSONTyped = VaccinationRecordsDtoToJSONTyped;
const Covid19RecordDto_1 = require("./Covid19RecordDto");
const VaccinationRecordDoseOnlyDto_1 = require("./VaccinationRecordDoseOnlyDto");
const VaccinationRecordWithTiterDto_1 = require("./VaccinationRecordWithTiterDto");
/**
 * Check if a given object implements the VaccinationRecordsDto interface.
 */
function instanceOfVaccinationRecordsDto(value) {
    return true;
}
function VaccinationRecordsDtoFromJSON(json) {
    return VaccinationRecordsDtoFromJSONTyped(json, false);
}
function VaccinationRecordsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'covid19': json['covid-19'] == null ? undefined : (0, Covid19RecordDto_1.Covid19RecordDtoFromJSON)(json['covid-19']),
        'influenza': json['influenza'] == null ? undefined : (0, VaccinationRecordDoseOnlyDto_1.VaccinationRecordDoseOnlyDtoFromJSON)(json['influenza']),
        'mmr': json['mmr'] == null ? undefined : (0, VaccinationRecordWithTiterDto_1.VaccinationRecordWithTiterDtoFromJSON)(json['mmr']),
        'varicella': json['varicella'] == null ? undefined : (0, VaccinationRecordWithTiterDto_1.VaccinationRecordWithTiterDtoFromJSON)(json['varicella']),
        'hepatitisB': json['hepatitis_b'] == null ? undefined : (0, VaccinationRecordWithTiterDto_1.VaccinationRecordWithTiterDtoFromJSON)(json['hepatitis_b']),
        'tdap': json['tdap'] == null ? undefined : (0, VaccinationRecordDoseOnlyDto_1.VaccinationRecordDoseOnlyDtoFromJSON)(json['tdap']),
    };
}
function VaccinationRecordsDtoToJSON(json) {
    return VaccinationRecordsDtoToJSONTyped(json, false);
}
function VaccinationRecordsDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'covid-19': (0, Covid19RecordDto_1.Covid19RecordDtoToJSON)(value['covid19']),
        'influenza': (0, VaccinationRecordDoseOnlyDto_1.VaccinationRecordDoseOnlyDtoToJSON)(value['influenza']),
        'mmr': (0, VaccinationRecordWithTiterDto_1.VaccinationRecordWithTiterDtoToJSON)(value['mmr']),
        'varicella': (0, VaccinationRecordWithTiterDto_1.VaccinationRecordWithTiterDtoToJSON)(value['varicella']),
        'hepatitis_b': (0, VaccinationRecordWithTiterDto_1.VaccinationRecordWithTiterDtoToJSON)(value['hepatitisB']),
        'tdap': (0, VaccinationRecordDoseOnlyDto_1.VaccinationRecordDoseOnlyDtoToJSON)(value['tdap']),
    };
}
//# sourceMappingURL=VaccinationRecordsDto.js.map